import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import {
  CartridgeRoleAssignmentFlow,
  CartridgeWithSelectableRoles,
  SelectableRole,
} from '@markant-platform/authorizer/model';
import { TranslocoModule } from '@jsverse/transloco';
import { UiCartridgeRolesAssignmentRoleComponent } from '../ui-cartridge-roles-assignment-role/ui-cartridge-roles-assignment-role.component';
import { UiCartridgeRoleLimitComponent } from './ui-cartridge-role-limit/ui-cartridge-role-limit.component';

@Component({
  selector: 'markant-platform-ui-cartridge-roles-assignment-card',
  standalone: true,
  imports: [
    CommonModule,
    MarkantElementsModule,
    TranslocoModule,
    UiCartridgeRolesAssignmentRoleComponent,
    UiCartridgeRoleLimitComponent,
  ],
  templateUrl: './ui-cartridge-roles-assignment-card.component.html',
  styleUrls: ['./ui-cartridge-roles-assignment-card.component.scss'],
})
export class UiCartridgeRolesAssignmentCardComponent {
  @Input({ required: true })
  cartridgeRoles!: CartridgeWithSelectableRoles;

  @Input({ required: true })
  flow!: CartridgeRoleAssignmentFlow;

  @Input()
  hasSuborganizations = false;

  @Input()
  isRoleLimitEnabled = false;

  @Output()
  roleAdded = new EventEmitter<SelectableRole>();

  @Output()
  roleRemoved = new EventEmitter<SelectableRole>();

  @Output()
  suborganizationEdit = new EventEmitter<SelectableRole>();

  protected readonly CartridgeRoleAssignmentFlow = CartridgeRoleAssignmentFlow;

  onRoleCardClick(role: SelectableRole): void {
    if (role.selected || !this.cartridgeRoles.limits?.allowsAssignment) {
      return;
    }

    this.roleAdded.emit(role);
  }

  onRemoveClick(role: SelectableRole): void {
    this.roleRemoved.emit(role);
  }

  onEditSuborganizationClick(role: SelectableRole): void {
    this.suborganizationEdit.emit(role);
  }
}
